import React, { useEffect, useState } from "react";
import { RightOutlined, CloseOutlined } from "@ant-design/icons";
import { Form, Button, Input, Select, Modal, message } from "antd";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import StyledPeoplePage from "./style";
import { useDispatch, useSelector } from "react-redux";
import PostUpdateData from "../../../../hooks/postUpdate";
import { setGetCreateAllCustomPeople } from "../../../../Redux/systemSlice";
import UseApi from "../../../Reusable/CallApi/UseApi";
// import UseApi from '../../../Reusable/CallApi/UseApi';
const { Option } = Select;

const EditCustomField = ({
  setCustomView,
  selectedData = {},
  customView,
  handleGetCustomData,
}) => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [formValues, setFormValues] = useState({});
  const [selectedType, setSelectedType] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [newOptionText, setNewOptionText] = useState("");
  const dispatch = useDispatch();
  const getCreateAllCustomPeople = useSelector(
    (state) => state.systemTracking.getCreateAllCustomPeople
  );
    const { request } = UseApi();

  console.log("selectedData", selectedData);

  const isEditMode = !!selectedData;
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const handleCancel = () => {
    setCustomView("people");
  };

  const onFinish = async () => {
    if (formValues.type === "dropdown" && dropdownOptions.length === 0) {
      message.error("Please add at least one dropdown option");
      return;
    }
    const payload = {
      field_name: formValues.field_name,
      field_type: formValues.type,
      mandatory: formValues.mandatory,
      visible_on_report: formValues.visible,
      field_options:
        formValues.type === "dropdown"
          ? JSON.stringify(dropdownOptions)
          : null,
      updated_at: new Date().toLocaleDateString(),
    };
    console.log("Payload0", payload);

    try {
    console.log("Payload1", payload);
    

 const response =  await request({
       endPoint: `/settings/adduserfield/${userInfo.clientId}`,
        method: "POST",
        data: payload,
      });

      console.log("Payload3", payload);
      console.log("response---->", response);

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        setModalMessage("Created");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
          setCustomView("people");
          form.resetFields();
        }, 2000);
        handleGetCustomData();
        // const res = response.response;
        // const postData = res.reduce((acc, item) => {
        //   return { ...acc, ...item };
        // }, {});

        // const newData = {
        //   key: postData.field_id,
        //   name: postData.field_name,
        //   type: postData.field_type,
        //   mandatory: postData.mandatory === true ? "Yes" : "No",
        //   visible: postData.visible_on_report === true ? "Yes" : "No",
        // };

        // dispatch(
        //   setGetCreateAllCustomPeople([newData, ...getCreateAllCustomPeople])
        // );
      } else {
        setModalMessage("Error occurred");
        setIsModalVisible(true); // Show error modal
        setTimeout(() => {
          setIsModalVisible(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error while saving custom field:", error);
      setModalMessage("Error occurred");
      setIsModalVisible(true); // Show error modal
      setTimeout(() => {
        setIsModalVisible(false);
      }, 2000);
    }
  };
  const onFinishEdit = async () => {
    if (formValues.type === "dropdown" && dropdownOptions.length === 0) {
      message.error("Please add at least one dropdown option");
      return;
    }
    const payload = {
      field_name: formValues.field_name,
      field_type: formValues.type,
      mandatory: formValues.mandatory,
      visible_on_report: formValues.visible,
      field_options:
        formValues.type === "dropdown"
          ? JSON.stringify(dropdownOptions)
          : null,
      created_at: selectedData.updated_at,
    };
    try {
      const response = await PostUpdateData({
        endPoint: `/settings/updateuserfield/${userInfo.clientId}/${selectedData.field_id}`,
        method: "PATCH",
        obj: payload,
      });
      if (response?.status === 200) {
        setModalMessage("Saved");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
          setCustomView("people");
          form.resetFields();
        }, 2000);
        handleGetCustomData();
        // const updatedData = {
        //   key: selectedData.field_id,
        //   name: payload.field_name,
        //   type: payload.field_type,
        //   mandatory: payload.mandatory ? "Yes" : "No",
        //   visible: payload.visible_on_report ? "Yes" : "No",
        // };
        // const updatedList = getCreateAllCustomPeople.map((item) =>
        //   item.key === selectedData.field_id ? updatedData : item
        // );
        // dispatch(setGetCreateAllCustomPeople(updatedList));
      } else {
        setModalMessage("Error occurred");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error while editing custom field:", error);
      setModalMessage("Error occurred");
      setIsModalVisible(true);
      setTimeout(() => {
        setIsModalVisible(false);
      }, 2000);
    }
    console.log("Edited");
  };
  const handleValuesChange = (changedValues, allValues) => {
    console.log("Changed Values: ", changedValues);
    console.log("All Values: ", allValues);
    // Set the form values in state if needed
    setFormValues(allValues);
  };

  console.log("formValues--->", formValues);
  useEffect(() => {
    if (selectedData) {
      form.setFieldsValue(selectedData);
      setFormValues(selectedData);
      setSelectedType(selectedData.type || "");
      try {
        const parsed = selectedData.field_options
          ? JSON.parse(selectedData.field_options)
          : [];
        setDropdownOptions(Array.isArray(parsed) ? parsed : []);
      } catch (error) {
        setDropdownOptions([]);
      }
    }
  }, [form, selectedData]);

  const handleTypeChange = (value) => {
    setSelectedType(value);
  };

  const handleAddOption = () => {
    const trimmed = newOptionText.trim();
    if (!trimmed || dropdownOptions.includes(trimmed)) {
      setNewOptionText("");
      return;
    }
    setDropdownOptions((prev) => [...prev, trimmed]);
    setNewOptionText("");
  };

  const handleRemoveOption = (option) => {
    setDropdownOptions((prev) => prev.filter((item) => item !== option));
  };

  return (
    <>
      <StyledPeoplePage>
        <div>
          <div className="flex text-left gap-3">
            <p onClick={() => setCustomView("people")} className="custom-field">
              Custom Field
            </p>
            <RightOutlined className="h-[24px]" />
            <p className="editing-creating-text">
              {isEditMode ? "Editing Custom Field" : "Creating Custom Fields"}
            </p>
          </div>
          <br />
          <Form
            form={form}
            name="custom-form"
            onFinish={customView === "custom-edit" ? onFinishEdit : onFinish}
            onValuesChange={handleValuesChange}
            layout="vertical"
          >
            <div className="flex justify-between">
              {/* Left Section */}
              <div className="w-[48%]">
                <Form.Item
                  name="field_name"
                  label={<span className="name-text">Name</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please enter the name",
                    },
                  ]}
                  style={{ textAlign: "left" }}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="mandatory"
                  label={<span className="mandatory-text">Mandatory</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please select a mandatory option",
                    },
                  ]}
                  style={{ textAlign: "left" }}
                >
                  <Select className="text-left">
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item>
              </div>

              {/* Right Section */}
              <div className="w-[48%]">
                <Form.Item
                  name="type"
                  label={<span className="type-text">Type</span>}
                  rules={[{ required: true, message: "Please select a type" }]}
                  style={{ textAlign: "left" }}
                >
                  <Select className="text-left" onChange={handleTypeChange}>
                    <Option value="text">Text</Option>
                    <Option value="dropdown">Dropdown</Option>
                    <Option value="checkbox">Checkbox</Option>
                    <Option value="date">Date</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="visible"
                  label={<span className="visible-text">Visible on Report</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please select visibility option",
                    },
                  ]}
                  style={{ textAlign: "left" }}
                >
                  <Select className="text-left">
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>

            {selectedType === "dropdown" && (
              <div className="dropdown-options-block" style={{ textAlign: "left" }}>
                <span className="type-text">Dropdown Options</span>
                <div className="dropdown-options-input-row">
                  <Input
                    placeholder="Enter an option and click Add"
                    value={newOptionText}
                    onChange={(e) => setNewOptionText(e.target.value)}
                    onPressEnter={(e) => {
                      e.preventDefault();
                      handleAddOption();
                    }}
                  />
                  <Button onClick={handleAddOption}>Add</Button>
                </div>
                <div className="dropdown-options-container">
                  {dropdownOptions.length === 0 && (
                    <span className="dropdown-options-empty">
                      No options added yet
                    </span>
                  )}
                  {dropdownOptions.map((option) => (
                    <span key={option} className="dropdown-option-tag">
                      {option}
                      <CloseOutlined onClick={() => handleRemoveOption(option)} />
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Bottom Buttons */}
            <div className="button-style">
              <Button className="cancel-button" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                className="save-create-button"
                type="primary"
                htmlType="submit"
                // onClick={onFinish}
              >
                {isEditMode ? "Save" : "Create"}
              </Button>
            </div>
          </Form>
        </div>
      </StyledPeoplePage>
      <Modal
        width={180}
        height={100}
        open={isModalVisible}
        footer={null}
        closable={false}
        centered
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Tick style={{ width: "34px", height: "34px" }} />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            {modalMessage}
          </p>
        </div>
      </Modal>
    </>
  );
};

export default EditCustomField;
